var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___OWw1LU",
  "RW": "MessageReactions.module__reactionContainer___OWw1LU",
  "sU": "MessageReactions.module__reactionButton___OWw1LU",
  "I1": "MessageReactions.module__reactionMe___OWw1LU",
  "iX": "MessageReactions.module__reactionInner___OWw1LU",
  "Zg": "MessageReactions.module__emoji___OWw1LU",
  "Ps": "MessageReactions.module__countWrapper___OWw1LU",
  "lG": "MessageReactions.module__reactionContainerDisabled___OWw1LU",
  "II": "MessageReactions.module__reactionButtonDisabled___OWw1LU",
  "Go": "MessageReactions.module__reactionPickerButton___OWw1LU",
  "SD": "MessageReactions.module__reactionPickerButtonActive___OWw1LU",
};

module.exports = exports;
